import api from './axios';

/**
 * Anaokulu Takip — anaokullarına verilen branş desteği.
 *
 * KURUMUN NORMAL İŞLEYİŞİYLE HİÇBİR BAĞI YOK (kullanıcının açık talimatı):
 * öğrenci, ödeme, ders ve sertifika uçları buradakilerle karışmaz.
 * Buradaki "öğrenci" ARYS öğrencisi DEĞİL, anaokulundaki bir çocuk.
 */

// --- Sezon ("2026-2027 Sezonu") — kurum geneli katalog ---
export const getPreschoolSeasons  = () => api.get('/preschool-seasons');
export const createPreschoolSeason = (data) => api.post('/preschool-seasons', data);
export const updatePreschoolSeason = (id, data) => api.put(`/preschool-seasons/${id}`, data);
export const deletePreschoolSeason = (id) => api.delete(`/preschool-seasons/${id}`);

// --- Kurum ---
export const getPreschools   = (params) => api.get('/preschools', { params });
export const getPreschool    = (id) => api.get(`/preschools/${id}`);
export const createPreschool = (data) => api.post('/preschools', data);
export const updatePreschool = (id, data) => api.put(`/preschools/${id}`, data);
export const deletePreschool = (id) => api.delete(`/preschools/${id}`);

// --- Anlaşma (sezon bazlı: ücret, ödeme günü, sertifika adedi) ---
export const createAgreement = (preschoolId, data) => api.post(`/preschools/${preschoolId}/agreements`, data);
export const getAgreement    = (id) => api.get(`/preschool-agreements/${id}`);
export const updateAgreement = (id, data) => api.put(`/preschool-agreements/${id}`, data);
export const deleteAgreement = (id) => api.delete(`/preschool-agreements/${id}`);

// --- Haftalık program (hangi gün, kaç saat) ---
export const createSchedule = (agreementId, data) => api.post(`/preschool-agreements/${agreementId}/schedules`, data);
export const deleteSchedule = (agreementId, id) => api.delete(`/preschool-agreements/${agreementId}/schedules/${id}`);

// --- Sınıf ve çocuklar ---
export const createPreschoolClass = (agreementId, data) => api.post(`/preschool-agreements/${agreementId}/classes`, data);
export const updatePreschoolClass = (agreementId, id, data) => api.put(`/preschool-agreements/${agreementId}/classes/${id}`, data);
export const deletePreschoolClass = (agreementId, id) => api.delete(`/preschool-agreements/${agreementId}/classes/${id}`);

export const getClassStudents = (agreementId, classId) =>
  api.get(`/preschool-agreements/${agreementId}/classes/${classId}/students`);
/** Toplu ekleme: okuldan gelen isim listesi tek seferde girilsin diye. */
export const createClassStudents = (agreementId, classId, students) =>
  api.post(`/preschool-agreements/${agreementId}/classes/${classId}/students`, { students });
export const updatePreschoolStudent = (agreementId, id, data) =>
  api.put(`/preschool-agreements/${agreementId}/students/${id}`, data);
export const deletePreschoolStudent = (agreementId, id) =>
  api.delete(`/preschool-agreements/${agreementId}/students/${id}`);

// --- Ders günleri ---
export const getLessons      = (agreementId, params) => api.get(`/preschool-agreements/${agreementId}/lessons`, { params });
export const createLesson    = (agreementId, data) => api.post(`/preschool-agreements/${agreementId}/lessons`, data);
export const updateLesson    = (agreementId, id, data) => api.put(`/preschool-agreements/${agreementId}/lessons/${id}`, data);
export const setLessonDone   = (agreementId, id, data) => api.patch(`/preschool-agreements/${agreementId}/lessons/${id}/done`, data);
// Yapildiysa ISLENEN KONU, yapilmadiysa SEBEP. Ayri bir uc: PUT tarih+saat
// zorunlu istiyor (tarih gidis-donusu bu projede gun kaymasina yol acti),
// /done ise durumu zorunlu istiyor.
export const setLessonNote   = (agreementId, id, data) => api.patch(`/preschool-agreements/${agreementId}/lessons/${id}/note`, data);
export const deleteLesson    = (agreementId, id) => api.delete(`/preschool-agreements/${agreementId}/lessons/${id}`);
/** Haftalık programdan ders günlerini üretir. Var olanı atlar, asla silmez. */
export const generateLessons = (agreementId, data) => api.post(`/preschool-agreements/${agreementId}/lessons/generate`, data);

// --- Ödeme (sabit aylık tutar, kesinti YOK) ---
export const getPayments      = (agreementId) => api.get(`/preschool-agreements/${agreementId}/payments`);
export const generatePayments = (agreementId, data) => api.post(`/preschool-agreements/${agreementId}/payments/generate`, data);
export const updatePayment    = (agreementId, id, data) => api.put(`/preschool-agreements/${agreementId}/payments/${id}`, data);
export const deletePayment    = (agreementId, id) => api.delete(`/preschool-agreements/${agreementId}/payments/${id}`);
export const getSeasonSummary = (params) => api.get('/preschool-season-summary', { params });

// --- Sertifika ---
export const getCertificateTemplates = () => api.get('/preschool-certificate-templates');
export const uploadCertificateTemplate = (formData) =>
  api.post('/preschool-certificate-templates', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteCertificateTemplate = (id) => api.delete(`/preschool-certificate-templates/${id}`);
export const generateClassCertificates = (agreementId, classId, data) =>
  api.post(`/preschool-agreements/${agreementId}/classes/${classId}/certificates`, data);
export const downloadCertificate = (id) =>
  api.get(`/preschool-certificates/${id}/download`, { responseType: 'blob' });
export const deleteCertificate = (id) => api.delete(`/preschool-certificates/${id}`);
